import {
  GenericSuggestion,
  SuggestionPipelines,
} from 'types/suggestions/CoreSuggestions';
import { LoadBuildingSuggestions } from 'types/suggestions/LoadBuildingSuggestions';

import { LoadBuildingHandledState } from '../types';

// Whether the backend says this card's load is already built in Drumkit or found in the TMS.
// Cards from older backends have no handledState and count as open.
export function isBuiltLoadBuildingSuggestion(
  suggestion: GenericSuggestion
): suggestion is LoadBuildingSuggestions {
  return (
    isLoadBuildingSuggestion(suggestion) &&
    suggestion.handledState === LoadBuildingHandledState.Built
  );
}

export function isLoadBuildingSuggestion(
  suggestion: GenericSuggestion
): suggestion is LoadBuildingSuggestions {
  return suggestion.pipeline === SuggestionPipelines.LoadBuilding;
}
